
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiClassificheDialog extends Serenity.EntityDialog<UtentiProdottiClassificheRow, any> {
        protected getFormKey() { return UtentiProdottiClassificheForm.formKey; }
        protected getIdProperty() { return UtentiProdottiClassificheRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiClassificheRow.localTextPrefix; }
        protected getNameProperty() { return UtentiProdottiClassificheRow.nameProperty; }
        protected getService() { return UtentiProdottiClassificheService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiClassificheRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiClassificheRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiClassificheRow.updatePermission; }

        protected form = new UtentiProdottiClassificheForm(this.idPrefix);

        constructor() {
            super();

            // auto enable / disable customer selection dropdown when radio buttons change
            this.form.Tipo.change(e => {
                var nTipo = +(this.form.Tipo.value);
                var bEsperienza = nTipo < 2;
                Serenity.EditorUtils.setReadOnly(this.form.IdProdottoEsperienza, bEsperienza);
            });
        }

        onSaveSuccess(response: Serenity.SaveResponse) {
            super.onSaveSuccess(response);

            Q.notifyError("AA");
            this.dialogClose();
        }
    }
}